import { render } from "./CardBarChart.vue?vue&type=template&id=a52af696&scoped=true"
import script from "./CardBarChart.vue?vue&type=script&lang=js"
export * from "./CardBarChart.vue?vue&type=script&lang=js"

import "./CardBarChart.vue?vue&type=style&index=0&id=a52af696&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a52af696"]])

export default __exports__